// ImportacionesXL utils - Sprint 44 Fase 3 Vista 10.
// Constantes y helpers para el modulo de importaciones (multi-modalidad).

export const TIPOS = [
  { k: 'usa',           label: 'USA',           icon: '\u{1F1FA}\u{1F1F8}' },
  { k: 'maritima',      label: 'Maritima',      icon: '\u{1F6A2}' },
  { k: 'courier',       label: 'Courier',       icon: '\u{2708}\u{FE0F}' },
  { k: 'consolidada',   label: 'Consolidada',   icon: '\u{1F4E6}' },
  { k: 'europa',        label: 'Europa',        icon: '\u{1F1EA}\u{1F1FA}' },
  { k: 'china',         label: 'China',         icon: '\u{1F1E8}\u{1F1F3}' },
  { k: 'fabrica',       label: 'Fabrica',       icon: '\u{1F3ED}' },
  { k: 'nacionalizada', label: 'Nacionalizada', icon: '\u{1F6C3}' },
  { k: 'local',         label: 'Local',         icon: '\u{1F1E8}\u{1F1F4}' },
];

export const TIPO_VARIANT = {
  usa: 'info', maritima: 'info', courier: 'warning',
  consolidada: 'indigo', europa: 'info', china: 'danger',
  fabrica: 'success', nacionalizada: 'neutral', local: 'neutral',
};

export const MONEDAS = ['USD', 'EUR', 'CNY', 'COP'];
export const MONEDA_OPTIONS = MONEDAS.map((m) => ({ value: m, label: m }));

export const ESTADOS = [
  { value: 'draft',       label: 'Borrador'    },
  { value: 'en_transito', label: 'En transito' },
  { value: 'arribada',    label: 'Arribada'    },
  { value: 'cerrada',     label: 'Cerrada'     },
  { value: 'cancelada',   label: 'Cancelada'   },
];
export const ESTADO_VARIANT = {
  draft: 'neutral', en_transito: 'info',
  arribada: 'warning', cerrada: 'success', cancelada: 'danger',
};

export const TABS = ['basicos', 'tracking', 'costos', 'lineas', 'documentos', 'auditoria'];
export const TAB_LABELS = {
  basicos: 'Basicos', tracking: 'Tracking', costos: 'Costos',
  lineas: 'Lineas', documentos: 'Documentos', auditoria: 'Auditoria',
};

export const EMPTY = {
  id: null,
  tipo_importacion: 'usa',
  referencia: '',
  descripcion: '',
  proveedor: '',
  supplier_id: null,
  fecha: '',
  moneda_base: 'USD',
  pais_origen: '',
  pais_destino: 'Colombia',
  flete: '',  flete_moneda:  'USD',
  aduana: '', aduana_moneda: 'USD',
  broker: '', broker_moneda: 'USD',
  otros: '',  otros_moneda:  'USD',
  trm_financiera: '', trm_financiera_fecha: '', trm_financiera_fuente: '',
  trm_aduanera: '',   trm_aduanera_fecha: '',   trm_aduanera_fuente: '',
  trm_manual: '',
  estado: 'draft',
  courier_id: '',
  courier_tracking: '',
  guia_aerea: '',
  peso_kg: '',
  volumen_m3: '',
};

export function fmtCop(v) {
  if (v === null || v === undefined || v === '') return '\u2014';
  const n = Number(v);
  if (Number.isNaN(n)) return '\u2014';
  return 'COP ' + n.toLocaleString('es-CO', { maximumFractionDigits: 0 });
}

export function fmtUsd(v) {
  if (v === null || v === undefined || v === '') return '\u2014';
  const n = Number(v);
  if (Number.isNaN(n)) return '\u2014';
  return 'USD ' + n.toLocaleString('es-CO', { maximumFractionDigits: 2 });
}

export function fmtNum(v) {
  if (v === null || v === undefined || v === '') return '\u2014';
  const n = Number(v);
  if (Number.isNaN(n)) return '\u2014';
  return n.toLocaleString('es-CO', { maximumFractionDigits: 2 });
}

export function showCostos(t)   { return t !== 'local'; }
export function showTrm(t)      { return t !== 'local'; }
export function showTracking(t) { return t === 'courier' || t === 'maritima'; }
export function showGuia(t)     { return t === 'usa'; }
export function showConsol(t)   { return t === 'consolidada'; }

export const TIPO_ADJUNTO_LABEL = {
  factura_proveedor: 'Factura proveedor',
  guia_aerea: 'Guia aerea',
  packing_list: 'Packing list',
  liquidacion_aduana: 'Liquidacion aduana',
  declaracion_importacion: 'Declaracion importacion',
  comprobante_pago: 'Comprobante pago',
  otros: 'Otros',
};
